export function footerWatermark() {
    const watermark = document.querySelector('.footer-watermark');

    if (!watermark) return;

    const paths = watermark.querySelectorAll('svg path');

    if (!paths.length) return;

    gsap.fromTo(
        paths,
        {
            yPercent: 110,
            rotation: 5,
            transformOrigin: '50% 100%',
            autoAlpha: 0
        },
        {
            yPercent: 0,
            rotation: 0,
            autoAlpha: 1,
            duration: 0.5,
            stagger: 0.2,
            ease: 'power4.out',
            scrollTrigger: {
                trigger: watermark,
                // Keep the reveal reachable when the cropped footer is short.
                start: 'clamp(top 80%)',
                once: true
            }
        }
    );
}
